import axios from 'axios'
import serverUrl from '@/assets/BaseServerUrl.js'

const prefsService = {
  async getPrefs(userId) {
    const res = await axios.get(`${serverUrl}/api/prefs/get`, { params: { userId } })
    return res.data
  },
  async setFriendRequestPolicy(userId, accept) {
    const res = await axios.post(`${serverUrl}/api/prefs/set-friend-requests`, { userId, accept })
    return res.data
  },
  async addToBlacklist(userId, targetUserId) {
    const res = await axios.post(`${serverUrl}/api/prefs/blacklist/add`, { userId, targetUserId })
    return res.data
  },
  async removeFromBlacklist(userId, targetUserId) {
    const res = await axios.post(`${serverUrl}/api/prefs/blacklist/remove`, { userId, targetUserId })
    return res.data
  },
  async setDnd(userId, peerUserId, dnd) {
    const res = await axios.post(`${serverUrl}/api/prefs/dnd/set`, { userId, peerUserId, dnd })
    return res.data
  },
  async setGlobalDnd(userId, enabled) {
    const res = await axios.post(`${serverUrl}/api/prefs/dnd/set-global`, { userId, enabled })
    return res.data
  }
}

export default prefsService
